import React, { useState, useMemo } from 'react';
import { Tab, Tabs } from '../../common/TabCustom';
import Modal from '../../common/Modal';
import Select from '../../common/Select';
import { object, func } from 'prop-types';
import { MODE_SELECTION, useForm } from '@laramie/ui';
import { GetMeses } from '../../../utils/helpers';

const PeriodoSeleccionModal = (props) => {

    const [modeSeleccion, setModeSeleccion] = useState(MODE_SELECTION.PERIODO);

    const [ formValues, formHandle, , ] = useForm({
        periodo: Number(props.data.periodoHasta),
        periodoDesde: Number(props.data.periodoDesde),
        periodoHasta: Number(props.data.periodoHasta),
        cuotaDesde: 1,
        cuotaHasta: 12,
    });

    const periodos = useMemo(() => {
        let periodos = [];
        for (let periodo=parseInt(props.data.periodoDesde); periodo <= parseInt(props.data.periodoHasta); periodo++) {
            periodos.push({key: periodo, value: periodo});
        }
        return periodos;
    }, [props.data]);

    //handles
    const handleClickAceptar = () => {
        const result = (modeSeleccion === MODE_SELECTION.PERIODO) ? {
            modeSeleccion: MODE_SELECTION.PERIODO,
            periodo: formValues.periodo.toString()
        } : {
            modeSeleccion: MODE_SELECTION.RANGO_PERIODO_CUOTA,
            periodoDesde: formValues.periodoDesde.toString() + formValues.cuotaDesde.toString().padStart(2,'0'),
            periodoHasta: formValues.periodoHasta.toString() + formValues.cuotaHasta.toString().padStart(2,'0')
        };
        props.onConfirm(result);
    };

    const handleClickCancelar = () => {
        props.onDismiss();
    }


    return (
        <>

        <Modal
            size="md"
            title="Determine un criterio de selección"
            onEscape={handleClickCancelar}
            body={(
                <Tabs
                    id="tabs-seleccion"
                    activeKey={modeSeleccion}
                    className="m-top-20"
                    onSelect={(tab) => setModeSeleccion(tab)}
                >

                    <Tab eventKey={MODE_SELECTION.PERIODO} title="Por período">
                        <div className='tab-panel'>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label htmlFor="periodo" className="form-label">Período</label>
                                    <Select
                                        name="periodo"
                                        className="form-control"
                                        value={ formValues.periodo }
                                        options={periodos.map(item => ({ value: item.key, label: item.value }))}
                                        onChange={ formHandle }
                                    />
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey={MODE_SELECTION.RANGO_PERIODO_CUOTA} title="Por rango período-cuota">
                        <div className='tab-panel'>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label htmlFor="periodoDesde" className="form-label">Período desde</label>
                                    <Select
                                        name="periodoDesde"
                                        className="form-control"
                                        value={ formValues.periodoDesde }
                                        options={periodos.map(item => ({ value: item.key, label: item.value }))}
                                        onChange={ formHandle }
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label htmlFor="cuotaDesde" className="form-label">Cuota desde</label>
                                    <Select
                                        name="cuotaDesde"
                                        className="form-control"
                                        value={ formValues.cuotaDesde }
                                        options={GetMeses().map(item => ({ value: item.key, label: item.cuota }))}
                                        onChange={ formHandle }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label htmlFor="periodoHasta" className="form-label">Período hasta</label>
                                    <Select
                                        name="periodoHasta"
                                        className="form-control"
                                        value={ formValues.periodoHasta }
                                        options={periodos.map(item => ({ value: item.key, label: item.value }))}
                                        onChange={ formHandle }
                                    />
                                </div>
                                <div className="mb-3 col-6">
                                    <label htmlFor="cuotaHasta" className="form-label">Cuota hasta</label>
                                    <Select
                                        name="cuotaHasta"
                                        className="form-control"
                                        value={ formValues.cuotaHasta }
                                        options={GetMeses().map(item => ({ value: item.key, label: item.cuota }))}
                                        onChange={ formHandle }
                                    />
                                </div>
                            </div>
                        </div>
                    </Tab>

                </Tabs>
            )}
            footer={(<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => handleClickCancelar() }>Cancelar</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
            </>)}
        />

        </>
    );
}

PeriodoSeleccionModal.propTypes = {
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

export default PeriodoSeleccionModal;